var _style, _path, _ellipse, _path2, _path3, _ellipse2, _ellipse3, _path4, _path5, _path6, _ellipse4, _ellipse5, _ellipse6, _path7, _ellipse7, _path8, _ellipse8, _ellipse9, _path9, _ellipse10, _path10, _path11, _path12, _ellipse11, _path13, _ellipse12, _path14, _ellipse13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.47,
    cy: 73.68,
    rx: 26.47,
    ry: 23.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M605.88,381.58H76.47c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h529.41 c14.62,0,26.47,10.6,26.47,23.68C632.35,370.98,620.5,381.58,605.88,381.58z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,476.31H76.47c-14.62,0-26.47-10.6-26.47-23.68s11.85-23.68,26.47-23.68h105.88c14.62,0,26.47,10.6,26.47,23.68 S196.97,476.31,182.35,476.31z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.47,
    cy: 547.37,
    rx: 26.47,
    ry: 23.68
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.47,
    cy: 642.11,
    rx: 26.47,
    ry: 23.68
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,760.53H76.47c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h105.88 c14.62,0,26.47,10.6,26.47,23.68C208.82,749.92,196.97,760.53,182.35,760.53z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35,855.26H76.47c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h105.88 c14.62,0,26.47,10.6,26.47,23.68C208.82,844.66,196.97,855.26,182.35,855.26z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.24,192.11H182.35c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h105.88 c14.62,0,26.47,10.6,26.47,23.68C314.71,181.5,302.86,192.11,288.24,192.11z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.24,
    cy: 547.37,
    rx: 26.47,
    ry: 23.68
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.24,
    cy: 642.11,
    rx: 26.47,
    ry: 23.68
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.24,
    cy: 926.32,
    rx: 26.47,
    ry: 23.68
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M500,286.84H394.12c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68H500c14.62,0,26.47,10.6,26.47,23.68 C526.47,276.24,514.62,286.84,500,286.84z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.12,
    cy: 831.58,
    rx: 26.47,
    ry: 23.68
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M923.53,97.37H500c-14.62,0-26.47-10.6-26.47-23.68S485.38,50,500,50h423.53C938.15,50,950,60.6,950,73.68 S938.15,97.37,923.53,97.37z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 642.11,
    rx: 26.47,
    ry: 23.68
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 736.84,
    rx: 26.47,
    ry: 23.68
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M711.77,192.11H605.88c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h105.88 c14.62,0,26.47,10.6,26.47,23.68C738.24,181.5,726.38,192.11,711.77,192.11z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.88,
    cy: 452.63,
    rx: 26.47,
    ry: 23.68
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,571.05H605.88c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h211.77 c14.62,0,26.47,10.6,26.47,23.68C844.12,560.45,832.27,571.05,817.65,571.05z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,855.26H605.88c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h211.77 c14.62,0,26.47,10.6,26.47,23.68C844.12,844.66,832.27,855.26,817.65,855.26z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M923.53,950H605.88c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h317.65 c14.62,0,26.47,10.6,26.47,23.68C950,939.39,938.15,950,923.53,950z"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 711.76,
    cy: 642.11,
    rx: 26.47,
    ry: 23.68
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M817.65,760.53H711.77c-14.62,0-26.47-10.6-26.47-23.68c0-13.08,11.85-23.68,26.47-23.68h105.88 c14.62,0,26.47,10.6,26.47,23.68C844.12,749.92,832.27,760.53,817.65,760.53z"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 817.65,
    cy: 263.16,
    rx: 26.47,
    ry: 23.68
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M923.53,476.31H817.65c-14.62,0-26.47-10.6-26.47-23.68s11.85-23.68,26.47-23.68h105.88c14.62,0,26.47,10.6,26.47,23.68 S938.15,476.31,923.53,476.31z"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 923.53,
    cy: 642.11,
    rx: 26.47,
    ry: 23.68
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4);
export default __webpack_public_path__ + "static/media/P4.008fac7d7266c682e818d26618bf1ca4.svg";
export { ForwardRef as ReactComponent };